import { combineReducers } from "redux";

import * as auth from "./authReducer";
import * as  builder from "./builderReducer"

export const rootReducer = combineReducers({
  auth: auth.reducer,
  builder: builder.reducer
});
